import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AutoComplete } from 'primeng/autocomplete';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { ContactsLienMembres, LinkedMembersTable } from 'src/app/shared/models/iContact/global/contacts-lien-membres';
import { ContactNewComponent } from '../contact-new/contact-new.component';
import { PostContactLienMembre } from 'src/app/shared/models/iContact/global/post-contact-lien-membre';
import * as _ from 'underscore';
import { ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as async from 'async';
import { DialogService } from 'primeng/dynamicdialog';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ContactFunctionDto, ContactMemberLinkDto, ContactMemberRelationLinkDto } from 'src/app/shared/interfaces';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
@Component({
  selector: 'app-contact-members-linked',
  templateUrl: './contact-members-linked.component.html',
  styleUrls: ['./contact-members-linked.component.scss'],
})
export class ContactMembersLinkedComponent implements OnInit, AfterViewInit {
  @Input() public contact: Contact;
  @Input() public contacts: Contact[];
  public membersForm: UntypedFormGroup;
  public contactFctList: SelectItem[] = [];
  public contactFiltered: Contact[] = []; // without existing links
  public filteredContacts: Contact[];
  public links: ContactsLienMembres[] = [];
  public linksMembers: LinkedMembersTable[] = [];
  public isDisabled: boolean;
  public typesRelations: SelectItem[] = [];
  public clonedLink: LinkedMembersTable[] = [];
  public contactName: string;
  public emailInvalid: boolean;
  public defaultRelation: SelectItem;
  public editMode = false;
  @Output() public memberLinkCount = new EventEmitter<number>();
  @Output() public editEnabled = new EventEmitter<boolean>();
  @ViewChild(AutoComplete) myAutoComplete: AutoComplete;
  public columns = [
    {
      field: 'nameContact1',
      header: 'Contact 1',
      align: 'center',
      sortable: 'true',
      width: '20px',
      format: (value) => {
        return value;
      },
    },
    {
      field: 'contactsLiensMembresRelations',
      header: 'Relation',
      align: 'center',
      sortable: 'true',
      width: '20px',
      format: (_value, item) => {
        return item.contactsLiensMembresRelations?.label;
      },
    },
    {
      field: 'nameContact2',
      header: 'Contact 2',
      align: 'center',
      sortable: 'true',
      width: '20px',
      format: (value) => {
        return value;
      },
    },
    {
      field: 'fonction',
      header: 'Fonction',
      format: (value) => {
        return value;
      },
    },
    {
      field: 'actions',
      header: 'Action',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
  ];

  constructor(
    private formbuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    public confirmationService: ConfirmationService,
    private dialogService: DialogService,
    private contactsService: ContactsService,
    private contactsGlobalService: ContactsGlobalService
  ) {}

  ngOnInit(): void {
    if (this.contacts?.length > 0) {
      this.contactFiltered = this.contacts;
    }

    this.contactName = (this.contact.nom ? this.contact.nom : '') + ' ' + (this.contact.prenom ? this.contact.prenom : '');

    this.initForm();
    this.getContactsFunctions();
    this.getTypesRelation();
    if (this.contact) {
      setTimeout(() => {
        this.getLinks();
      }, 1000);
    }
  }

  ngAfterViewInit(): void {
    if (this.myAutoComplete) {
      this.myAutoComplete.renderer.setAttribute(this.myAutoComplete?.inputEL?.nativeElement, 'autocomplete', 'no');
    }
  }

  public initForm(): void {
    this.membersForm = this.formbuilder.group({
      members: new UntypedFormControl(null),
    });
  }

  public getContactsFunctions(): void {
    this.contactsGlobalService.fetchContactFunctions().subscribe({
      next: (response: ContactFunctionDto[]) => {
        response.map((item) => {
          const element = {
            label: item.fonction,
            value: { label: item.fonction, value: item.id },
          };
          this.contactFctList.push(element);
        });
        this.contactFctList = _.sortBy(this.contactFctList, 'label');
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error : ', error);
      },
    });
  }

  public getTypesRelation(): void {
    this.typesRelations = [];
    this.contactsGlobalService.fetchContactMembersRelationsLinks().subscribe({
      next: (res: ContactMemberRelationLinkDto[]) => {
        res.map((item) => {
          if (item.premierDescription) {
            const element = {
              label: item.premierDescription.toLowerCase(),
              value: { label: item.premierDescription, value: item.id },
            };
            this.typesRelations.push(element);
          }
        });
        this.typesRelations = _.sortBy(this.typesRelations, 'label');
        this.defaultRelation = this.typesRelations.find((r) => r.value.label === 'est lié à');
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  public getLinks(): void {
    this.linksMembers = [];
    const temp: LinkedMembersTable[] = [];
    let temp2: LinkedMembersTable[] = [];
    this.links = [];
    async.waterfall(
      [
        (cb) => {
          if (this.contact) {
            cb(null);
          }
        },
        (cb) => {
          this.contactsGlobalService
            .fetchContactMembersLinks({ FlagDelete: 0, PremierContactID: this.contact.id })

            .subscribe({
              next: (response) => {
                response.map((c) => {
                  this.links.push(new ContactsLienMembres(c));
                });
                response.map((l) => {
                  if (l.secondContact && l.secondContact['typeSociete'] === false) {
                    let contactName = '';
                    contactName = (l.secondContact.prenom ? l.secondContact.prenom : '') + ' ' + (l.secondContact.nom ? l.secondContact.nom : '');

                    let relation;
                    if (l.contactsLiensMembresRelations && l.contactsLiensMembresRelations.id) {
                      relation = {
                        label: l.contactsLiensMembresRelations.premierDescription,
                        value: l.contactsLiensMembresRelations.id,
                      };
                    } else {
                      relation = null;
                    }

                    temp.push({
                      linkId: l.id,
                      nameContact2: contactName,
                      nameContact1: this.contactName,
                      secondContactId: l.secondContact.id,
                      contactsLiensMembresRelations: relation ? relation : null,
                      fonction: l.fonction.fonction ?? null,
                      contactAsFirst: true,
                    });
                  }
                });
                cb(null);
              },
              error: (error) => {
                console.error('Error : ', error);
              },
            });
        },
        (cb) => {
          this.contactsGlobalService
            .fetchContactMembersLinks({
              FlagDelete: 0,
              SecondContactID: this.contact.id,
            })
            .subscribe({
              next: (response: ContactMemberLinkDto[]) => {
                response.map((l) => {
                  if (l.premierContact && l.premierContact['typeSociete'] === false) {
                    const contactName =
                      (l.premierContact.prenom ? l.premierContact.prenom : '') + ' ' + (l.premierContact.nom ? l.premierContact.nom : '');

                    let relation;
                    if (l.contactsLiensMembresRelations && l.contactsLiensMembresRelations.id) {
                      relation = {
                        label: l.contactsLiensMembresRelations.secondDescription,
                        value: l.contactsLiensMembresRelations.id,
                      };
                    } else {
                      relation = null;
                    }

                    temp2.push({
                      linkId: l.id,
                      nameContact2: contactName,
                      nameContact1: this.contactName,
                      secondContactId: l.secondContact.id,
                      contactsLiensMembresRelations: relation ? relation : '',
                      fonction: l.fonction.fonction ?? null,
                      contactAsFirst: false,
                    });
                  }
                });
                cb(null);
              },
              error: (error) => {
                console.error('Error : ', error);
                temp2 = [];
                cb(null);
              },
            });
        },
        (cb) => {
          this.contactsService.getLowInformationsContactsiCourrier({ includeContactParent: true }).subscribe({
            next: (response) => {
              if (response.length > 0) {
                response.map((contact) => {
                  const newContact = new Contact(contact);
                  if (newContact) {
                    newContact.label = (newContact.prenom ? newContact.prenom : '') + ' ' + (newContact.nom ? newContact.nom : '');
                    newContact.value = newContact.id ? newContact.id : null;
                    newContact.name = (newContact.prenom ? newContact.prenom + ' ' : '') + (newContact.nom ? newContact.nom : '');
                    this.contacts.push(newContact);
                  }
                });
                this.contacts = _.sortBy(temp, 'label');
                cb(null);
              }
            },
            error: (error) => {
              console.error('Error : ', error);
            },
          });
        },
      ],
      () => {
        this.linksMembers = temp.concat(temp2).reverse();
        this.contactFiltered = this.contacts.filter(
          (contact) =>
            contact.id !== this.contact.id && contact.typeSociete === false && !this.linksMembers.some((link) => contact.id === link.secondContactId)
        );
      }
    );
  }

  public search(event, mode?: string): void {
    const query = event.query;
    this.filteredContacts = [];
    switch (mode) {
      case 'contact':
        this.filteredContacts = this.filter(query, this.contacts?.length > 0 ? this.contacts : this.contactFiltered, mode);
        break;
    }
  }
  public filter(query, list: Contact[], mode?: string): Contact[] {
    const filtered: Contact[] = [];

    switch (mode) {
      case 'contact':
        list.map((contact) => {
          if (contact.name && contact.name.toLowerCase().includes(query.toLowerCase())) {
            filtered.push(contact);
          }
        });
        break;
    }
    return filtered;
  }

  public onSelectMember(member): void {
    this.editEnabled.emit(true);

    const newMember = {
      linkId: member.id,
      nameContact2: member.name,
      nameContact1: this.contactName,
      contactsLiensMembresRelations: this.defaultRelation && this.defaultRelation !== null ? this.defaultRelation.value : '',
      fonction: member.fonction,
      secondContactId: member.id,
    };
    this.contactFiltered = this.contactFiltered.filter((x) => x.id !== member.id);
    this.linksMembers.push(newMember);
    this.linksMembers = [...this.linksMembers].reverse();
    this.memberLinkCount.emit(this.linksMembers.length);
    this.toastr.warning(
      "Afin de terminer l'enregistrement du lien, veuillez compléter les champs indiqués en rouge en cliquant sur le bouton d'édition et en validant ensuite vos modifications",
      'Attention'
    );
  }

  public onSelectFct(e, rowData): void {
    rowData.fonction = e.value;
  }

  addContact(): void {
    const ref = this.dialogService.open(ContactNewComponent, {
      styleClass: 'super-compos-modal-content',
      dismissableMask: false,
      width: '70vw',
      closable: false,
      showHeader: false,
      baseZIndex: 1000,
      data: {
        companyMode: false,
        caller: 'linked',
        hideSwitch: true,
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          const newMember = {
            linkId: value.id,
            nameContact1: this.contactName,
            nameContact2: (value.nom ? value.nom : '') + ' ' + (value.prenom ? value.prenom : ''),
            contactsLiensMembresRelations: this.defaultRelation && this.defaultRelation !== null ? this.defaultRelation.value : '',
            fonction: value.fonction,
            secondContactId: value.id,
          };
          this.linksMembers.push(newMember);
          this.memberLinkCount.emit(this.linksMembers.length);
          this.contactFiltered = this.contactFiltered.filter((x) => x.id !== value.id);
          this.toastr.warning(
            "Afin de terminer l'enregistrement du lien, veuillez compléter les champs indiqués en rouge en cliquant sur le bouton d'édition et en validant ensuite vos modifications",
            'Attention'
          );
        }
      },
    });
  }

  updateMemberLink(relationId: number, member: PostContactLienMembre): void {
    console.log(relationId, member);
    // this.contactsService.put(`/Global/contactsLiensMembres/${relationId}`, member).subscribe(
    //   {next:() => {
    //     this.toastr.success('Merci', 'Lien modifié!');
    //     this.editEnabled.emit(false);
    //   },
    //   error:(error) => {
    //     console.error('Error : ', error);
    //     this.toastr.error("Une erreur s'est produite.");
    //   }}
    // );
  }

  public saveMember(member: PostContactLienMembre): void {
    console.log(member);
    // this.contactsService.post(`/Global/contactsLiensMembres`, member).subscribe(
    //   {next:(response) => {
    //     const newMemberLink = new ContactsLienMembres(response);
    //     const newMember = this.linksMembers.find((x) => x.id === newMemberLink.secondContact.id);
    //     newMember.linkId = newMemberLink.id;
    //     newMember.contactAsFirst = true;
    //     this.editEnabled.emit(false);
    //     this.toastr.success('Merci', 'Lien ajouté!');
    //   },
    //   error:(error) => {
    //     console.error('Error : ', error);
    //     this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
    //   }}
    // );
  }

  public remove(data): void {
    console.log(data);
    // this.confirmationService.confirm({
    //   message: 'Êtes-vous sûr de vouloir supprimer ce lien?',
    //   accept: () => {
    //     if (data.linkId) {
    //       this.contactsService.delete(`/Global/contactsLiensMembres/${data.linkId}`).subscribe(
    //        {next: () => {
    //           this.toastr.success('Merci', 'Lien supprimé');
    //           this.ngOnInit();
    //         },
    //         error:(error) => {
    //           console.error('Error : ', error);
    //           this.toastr.error("Une erreur s'est produite");
    //         }}
    //       );
    //     } else {
    //       this.toastr.success('Merci', 'Lien supprimé');
    //       this.ngOnInit();
    //     }
    //   },
    // });
  }

  onRowEditInit(link): void {
    this.clonedLink['linkId'] = { ...link };
    this.editEnabled.emit(true);
  }

  onRowEditSave(link): void {
    if (link?.linkId !== undefined) {
      // existing link
      let link2Edit: PostContactLienMembre;
      if (link.contactAsFirst) {
        link2Edit = new PostContactLienMembre({
          id: link.linkId,
          contactsLiensMembresRelationsID: link.contactsLiensMembresRelations ? link.contactsLiensMembresRelations.value : null,
          premierContactID: this.contact.id,
          secondContactID: link.secondContactId,
          contactFonctionID: link.fonction.value,
        });
      } else {
        link2Edit = new PostContactLienMembre({
          id: link.linkId,
          contactsLiensMembresRelationsID: link.contactsLiensMembresRelations ? link.contactsLiensMembresRelations.value : null,
          premierContactID: link.secondContactId,
          secondContactID: this.contact.id,
          contactFonctionID: link.fonction.value,
        });
      }

      this.updateMemberLink(link.linkId, link2Edit);
    } else {
      // new link
      const member = new PostContactLienMembre({
        contactsLiensMembresRelationsID: link.contactsLiensMembresRelations ? link.contactsLiensMembresRelations.value : null,
        premierContactID: this.contact.id,
        secondContactID: link.secondContactId,
        contactFonctionID: link.fonction.value,
      });

      this.saveMember(member);
    }
  }

  onRowEditCancel(index: number): void {
    this.linksMembers[index] = this.clonedLink['linkId'];
    delete this.clonedLink['linkId'];
  }
}
